<template>
	<router-view></router-view>
</template>

<script setup>
import { onBeforeMount, onMounted } from 'vue';
import {useMainStore} from '@/utils/store.js';
import {LocalRes} from '@/utils/request.js';
import { Message } from '@arco-design/web-vue';

onBeforeMount(() => {
    console.log('mounted');
});

onMounted(async () => {
    if (window.location.protocol == "https:") {
        Message.error("本站不支持https访问，请检查url地址");
    }

    const store = useMainStore();
    const res = await LocalRes.get('config.json');

    console.log("get config.json", res.data);
    store.setGlobalConfig(res.data);
});
</script>

<style lang="scss">	
/** 这里放一些自定义的全局css*/
html, body {
    height: 100%;
    margin: 0;
    padding: 0;
    background-color: var(--color-bg-1);
    color: var(--color-text-1);
}
.hide { display:none; }
.text-center{ text-align: center; }
.full-w { width: 100%; }
.full-h { height: 100%; }
.float-r { float: right; }
.text-center {text-align: center;}
.align-center-x {margin-left: auto; margin-right: auto;}
.align-center-y {margin-top: auto; margin-bottom: auto;}
.relative {position:relative}
.absolute {position:absolute;}
</style>
